// components/FullScreenLoader.jsx
import React from "react";
import { ClipLoader } from "react-spinners";

const FullScreenLoader = ({ message = "Loading..." }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="flex flex-col items-center">
        <ClipLoader size={60} color="#004276" />
        <p className="mt-4 text-lg text-[#004276] font-semibold animate-pulse">
          {message}
        </p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
